import {useState, useRef, useEffect} from 'react'
import ArrowRight from '../../assets/images/Doodles/arrow_right.svg'
import { useTranslation } from 'react-i18next';

function SolutionItemMobile ({className, title, description, children, Image, YOffset}) {
    const { t } = useTranslation(['common']);
    const [contentHeight, setContentHeight] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null);    

    // Función para medir la altura del contenido
  const measureContent = () => {
    if (contentRef.current) {
      const newHeight = contentRef.current.scrollHeight;
      setContentHeight(newHeight);
    }
  };

  // listener de resize
  useEffect(() => {
    measureContent();

    // Función throttled
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        measureContent();
      }, 100); // Espera 100m
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [children]); // Re-ejecutar cuando cambie children

  useEffect(() => {
    if (!contentRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      measureContent();
    });

    resizeObserver.observe(contentRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [children]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

    return(
        <div 
            className={`relative w-full bg-black overflow-hidden cursor-pointer transition-all duration-500 ease-in-out ${className}`}
            style={{
                height: isExpanded ? `${contentHeight}px` : `${15}rem`
            }}
            onClick={toggleExpanded}
            >
            <img src={Image} alt="" className={`object-cover object-[center_${YOffset}%] w-full h-full`} />
            <div className='h-full w-full opacity-60 absolute bottom-0 left-0 bg-gradient-to-br from-bluekali-black to-bluekali-cerulean-blue'/>
            
            <div className='absolute top-0 left-0 pt-6 pl-6 w-full h-full' ref={contentRef}>
                <h2 className=" w-1/2 text-white text-3xl font-medium">
                    {title}
                </h2>

                <p className='w-2/3 text-sm text-white/80'>
                    {description}
                </p>

                <div className={` transition-all duration-200 ${
                isExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
            }`}>
                <div className="text-white mt-8">
                {children}
                </div>

                <div className='h-20'/>
            </div>
            </div>

            <div className='absolute bottom-0 right-0 pr-6 pb-6'>
                <button>
                    <div className='flex items-center'>
                        <p className={`font-bold mr-2 text-sm ${isExpanded ? 'hidden' : 'block'}`}>
                            {t('solutions.readmore')}
                        </p>
                        <p className={`font-bold mr-2 text-sm ${isExpanded ? 'block' : 'hidden'}`}>
                            {t('solutions.readless')}
                        </p>
                        <img src={ArrowRight} alt='' className={`h-5 w-5 text-white transition-transform duration-300 ${
                            isExpanded ? '-rotate-90' : 'rotate-0'
                            }`}/>
                    </div>
                </button>
            </div>

            
            
        </div>

    )
}

export default SolutionItemMobile